/* eslint-disable max-len */
import { SUBITEM_REQUIRED } from '_utils/constant'
import React from 'react'
import ImageSlider from '_components/ImageSlider'
import QuantityStepper from './QuantityStepper'
import InventoryBadge from '../../components/InventoryBadge'
import SubItemChooseQuantities from '../../components/SubItemChooseQuantities'

const ProductCaseRow = ({
  product,
  price,
  quantityEntry,
  soldOut,
  edittingOrder,
  canAddAnother,
  canRemove,
  // getValueSelect,
  onSubItemChange,
  onDecrement,
  onIncrement,
  onQuantityInputChange,
  onQuantityInputBlur,
  onAddAnother,
  onRemove,
}) => {
  const hasSubItems = !!product.subItems?.length
  const inventory = (product?.maxQuantity || 0) - (product?.newOrderCount || 0)

  const renderFooter = () => (
    <div className="edv2-product-row__footer">
      {(!soldOut || edittingOrder) && (
        <div className="edv2-product-row__action">
          <QuantityStepper
            value={quantityEntry?.quantityInput}
            onDecrement={onDecrement}
            onIncrement={onIncrement}
            onInputChange={(e) => onQuantityInputChange(parseInt(e.target.value, 10))}
            onInputBlur={(e) => onQuantityInputBlur(parseInt(e.target.value, 10))}
          />
        </div>
      )}
    </div>
  )

  const renderSingleOptions = (subItem) => {
    const selectedSubItems = quantityEntry?.subItems || []
    return (
      <div className="edv2-subitems__single-list">
        {subItem.list?.map((l, index) => {
          const isSelected = selectedSubItems.some(
            (item) => item.type === subItem.type && item.name === l.name
          )
          const handleSelect = () => {
            const nextValue = isSelected ? null : { name: l.name, price: l.price }
            onSubItemChange(subItem, nextValue)
          }

          return (
            <div
              key={index}
              style={{ display: 'flex', alignItems: 'center', padding: '8px 0', cursor: 'pointer', borderBottom: '0.5px solid #f0f0f0' }}
              onClick={handleSelect}
            >
              <div style={{ width: '16px', height: '16px', borderRadius: '50%', border: isSelected ? '5px solid #009A97' : '1px solid #D3D1C7', marginRight: '10px' }}></div>
              <span style={{ flex: 1, fontSize: '12px', color: '#1a1a18' }}>{l.name}</span>
              <span style={{ fontSize: '12px', color: '#888780' }}>+{l.price ? `$${l.price}` : '$0'}</span>
            </div>
          )
        })}
      </div>
    )
  }

  const renderMultipleOptions = (subItem) => {
    const selectedSubItems = quantityEntry?.subItems || []
    return (
      <div className="edv2-subitems__multiple-list">
        {subItem.list?.map((l, index) => {
          const selectedSubItem = selectedSubItems.find(
            (item) => item.type === subItem.type && item.name === l.name
          )
          const quantity = selectedSubItem ? (selectedSubItem.quantity ?? selectedSubItem.qty ?? 1) : 0
          const isSelected = quantity > 0

          const handleToggle = () => {
            if (isSelected) {
              onSubItemChange(subItem, { name: l.name, price: l.price, quantity: 0 })
            } else {
              onSubItemChange(subItem, { name: l.name, price: l.price, quantity: 1 })
            }
          }

          const handleDecrement = (e) => {
            e.stopPropagation()
            const nextQty = quantity <= 1 ? 0 : quantity - 1
            if (quantity <= 1) {
              onSubItemChange(subItem, { name: l.name, price: l.price, quantity: 0 })
            } else {
              onSubItemChange(subItem, { name: l.name, price: l.price, quantity: nextQty })
            }
          }

          const handleIncrement = (e) => {
            e.stopPropagation()
            const nextQty = quantity + 1
            onSubItemChange(subItem, { name: l.name, price: l.price, quantity: nextQty })
          }

          return (
            <div
              key={index}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: '0.5px solid #f0f0f0' }}
            >
              <div
                onClick={handleToggle}
                style={{ width: '16px', height: '16px', borderRadius: '3px', border: isSelected ? '1.5px solid #80CCCB' : '1.5px solid #D3D1C7', background: isSelected ? '#80CCCB' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer', transition: 'all 0.12s' }}
              >
                {isSelected && (
                  <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="white" strokeWidth="2.5">
                    <polyline points="2 6 5 9 10 3" />
                  </svg>
                )}
              </div>
              <span style={{ fontSize: '11px', fontWeight: 500, color: isSelected ? '#1a1a18' : '#5F5E5A', flex: 1 }}>{l.name}</span>
              <span style={{ fontSize: '10px', fontWeight: 600, color: isSelected ? '#009A97' : '#5F5E5A', minWidth: '32px', textAlign: 'right' }}>
                +{l.price ? `$${l.price}` : '$0'}
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: '4px' }}>
                <button
                  type="button"
                  onClick={handleDecrement}
                  disabled={!isSelected}
                  style={{ width: '18px', height: '18px', borderRadius: '50%', border: '0.5px solid #D3D1C7', background: 'white', color: '#888780', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 700, cursor: isSelected ? 'pointer' : 'default', opacity: isSelected ? 1 : 0.3 }}
                >
                  −
                </button>
                <span style={{ fontSize: '11px', fontWeight: 600, color: isSelected ? '#1a1a18' : '#5F5E5A', minWidth: '12px', textAlign: 'center' }}>
                  {quantity}
                </span>
                <button
                  type="button"
                  onClick={handleIncrement}
                  disabled={!isSelected}
                  style={{ width: '18px', height: '18px', borderRadius: '50%', border: 'none', background: '#80CCCB', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 700, cursor: isSelected ? 'pointer' : 'default', opacity: isSelected ? 1 : 0.3 }}
                >
                  +
                </button>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  if (!hasSubItems) {
    return (
      <div className="edv2-product-row">
        <div className="edv2-product-row__image-group">
          <div className="edv2-product-row__image">
            <ImageSlider images={product.photoUrls || []} alt={product.name} />
          </div>
          <div className="edv2-product-row__stats">{product.orderCount || 0} order(s) made</div>
        </div>

        <div className="edv2-product-row__content">
          <div className="edv2-product-row__header">
            <div className="edv2-product-row__name">{product.name}</div>
            <div className="edv2-product-row__price">
              <span>${price?.toFixed(2)}</span>
              {canRemove && (
                <button className="edv2-product-row__remove" onClick={onRemove}>
                  ✕
                </button>
              )}
            </div>
          </div>

          <div className="edv2-product-row__desc">{product.description}</div>
          {product.splitCasePurchase && Object.keys(product.splitCasePurchase).length > 0 && (
            <span className="edv2-product-row__meta">{product.splitCasePurchase.itemsPerCase} per case/carton</span>
          )}
          <InventoryBadge count={inventory} soldOut={soldOut} />

          {renderFooter()}
        </div>
      </div>
    )
  }

  return (
    <div className="edv2-product-row edv2-product-row--has-subitems">
      {hasSubItems && product.subItems[0] && (
        <div className="edv2-subitem-pill-container">
          {(() => {
            const firstSub = product.subItems[0]
            if (firstSub.trackInventory) {
              return <span className="edv2-subitem-pill edv2-subitem-pill--quantities">CHOOSE QUANTITIES</span>
            }
            if (firstSub.selectionMode === 'multiple') {
              return <span className="edv2-subitem-pill edv2-subitem-pill--combo">BUILD A COMBO</span>
            }
            return <span className="edv2-subitem-pill edv2-subitem-pill--single">CHOOSE ONE — price fixed regardless of option</span>
          })()}
        </div>
      )}
      <div className="edv2-product-row__main">
        <div className="edv2-product-row__image-group">
          <div className="edv2-product-row__image">
            <ImageSlider images={product.photoUrls || []} alt={product.name} />
          </div>
          <div className="edv2-product-row__stats">{product.orderCount || 0} order(s) made</div>
        </div>

        <div className="edv2-product-row__content">
          <div className="edv2-product-row__header">
            <div className="edv2-product-row__name">{product.name}</div>
            <div className="edv2-product-row__price">
              <span>${price?.toFixed(2)}</span>
              {canRemove && (
                <button className="edv2-product-row__remove" onClick={onRemove}>
                  ✕
                </button>
              )}
            </div>
          </div>

          <div className="edv2-product-row__desc">{product.description}</div>
          {product.splitCasePurchase && Object.keys(product.splitCasePurchase).length > 0 && (
            <span className="edv2-product-row__meta">{product.splitCasePurchase.itemsPerCase} per case/carton</span>
          )}
          {(!product.subItems[0] || !product.subItems[0].trackInventory) && (
            <InventoryBadge count={inventory} soldOut={soldOut} />
          )}
        </div>
      </div>

      <div className="edv2-subitems">
        {product.subItems.map((s, i) => {
          const isTrack = s.trackInventory
          return (
            <div
              key={i}
              className={isTrack ? '' : `edv2-subitems__option edv2-subitems__option--${s.selectionMode || 'single'}`}
              style={isTrack ? { marginTop: '10px' } : { marginTop: '10px', padding: '10px', background: '#FAFAF8', borderRadius: '8px', border: '0.5px solid #f0f0f0' }}
            >
              {!isTrack && (
                <div className="edv2-subitems__title" style={{ fontSize: '9px', fontWeight: 600, color: '#888780', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '6px' }}>
                  {s.type}
                  {s.required === SUBITEM_REQUIRED ? (
                    <> <span style={{ color: '#E24B4A', fontWeight: 400 }}>· Required</span></>
                  ) : (
                    <> <span style={{ color: '#B4B2A9', fontWeight: 400 }}>· Optional</span></>
                  )}
                </div>
              )}
              {s.trackInventory ? (
                <SubItemChooseQuantities
                  subItem={s}
                  quantityEntry={quantityEntry}
                  price={price}
                  onSubItemChange={onSubItemChange}
                />
              ) : s.selectionMode === 'multiple' ? (
                renderMultipleOptions(s)
              ) : (
                renderSingleOptions(s)
              )}
            </div>
          )
        })}
      </div>

      {!product.subItems[0]?.trackInventory && (
        <div className="edv2-product-row__links">
          {canAddAnother && (
            <button className="edv2-add-another-btn" onClick={onAddAnother}>
              <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 1v10M1 6h10" />
              </svg>
              Add another order with different options
            </button>
          )}
          {renderFooter()}
        </div>
      )}
    </div>
  )
}

export default ProductCaseRow
